import { call, put, takeEvery, select } from 'redux-saga/effects'
import actionTypes from '../actions/actionTypes'
import accessibilityActions from '../actions/accessibilityActions'
import accessibilityLoader from '../../sync/accessibilityLoader'
import { IGameActivity, AnswerType, IGameAnswer } from '../../helpers/data/question'
import { IStore } from '../reducers'
import altTextContextTypes from '../../helpers/enums/altTextContextTypes'

function* handleGameUpdate(action: any): Generator<any, any, any> {
	try {
		const activities: IGameActivity[] = action.payload.activities
		const accessibility = yield select((state: IStore) => state.accessibility)

		if (!activities || activities.length === 0) {
			return
		}

		// Iterate through all activities (questions)
		for (const activity of activities) {
			if (activity.payload && activity.payload.answers) {
				const answers: IGameAnswer[] = activity.payload.answers

				// Iterate through all answers in the question
				for (const answer of answers) {
					// Only process image answers that have an assetUid
					if (
						answer.media.type === AnswerType.IMAGE &&
						answer.media.payload.assetUid &&
						!accessibility[answer.uid]
					) {
						try {
							// Fetch accessibility data for the answer image
							const accessibilityData = yield call(
								accessibilityLoader.getAssetAccessibilityData,
								answer.media.payload.assetUid,
								answer.uid, // entityUid
								altTextContextTypes.ANSWER, // entityType
								altTextContextTypes.ANSWER // elementId - used the same as entityType to get the elementId from the answer
							)

							// Store the fetched data in the accessibility state
							yield put(
								accessibilityActions.fetchAccessibilityData(
									answer.uid,
									accessibilityData.altText || '',
									accessibilityData.isDecorative || false
								)
							)
						} catch (error) {
							console.error(`Error fetching accessibility data for answer ${answer.uid}:`, error)
						}
					}
				}
			}
		}
	} catch (error) {
		console.error('Error in handleGameUpdate accessibility saga:', error)
	}
}

export default [takeEvery(actionTypes.GAME_UPDATE, handleGameUpdate)]
